import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/img/icons/search.svg'
import _imports_1 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "row mb-40" }
const _hoisted_3 = { class: "col-lg-4" }
const _hoisted_4 = { class: "form-group mb-25" }
const _hoisted_5 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "form-group mb-25" }
const _hoisted_8 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "form-group mb-25" }
const _hoisted_12 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_13 = { value: null }
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "promotion-notice mt-2"
}
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "form-group mb-25" }
const _hoisted_18 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_19 = { value: null }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_24 = { class: "search-area style-two position-relative w-100" }
const _hoisted_25 = { class: "position-relative" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = {
  key: 0,
  class: "position-absolute w-100 bg-white shadow rounded-1 mt-1 z-3 overflow-auto",
  style: {"max-height":"300px"}
}
const _hoisted_28 = { class: "list-unstyled mb-0" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "d-flex justify-content-between" }
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = { class: "d-flex justify-content-between fs-12 text-muted" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  class: "delete-popup offcanvas offcanvas-end border-0",
  tabindex: "-1",
  id: "deletePopup"
}
const _hoisted_37 = { class: "offcanvas-body p-0" }
const _hoisted_38 = { class: "delete-success" }
const _hoisted_39 = { class: "text-white fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_SelectedProducts = _resolveComponent("SelectedProducts")!
  const _component_SubmitPurchase = _resolveComponent("SubmitPurchase")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, {
        pageTitle: "create_sale",
        items: _ctx.breadcrumbItems,
        showHome: false
      }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("sales_page.date")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.saleDate) = $event)),
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.saleDate]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t("sales_page.reference_no")) + " ", 1),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white",
              placeholder: _ctx.$t('sales_page.reference_no'),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referenceNo) = $event)),
              readonly: ""
            }, null, 8, _hoisted_9), [
              [_vModelText, _ctx.referenceNo]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.$t("sales_page.customer")) + " ", 1),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "bg-white border-0 rounded-1 fs-14 text-optional w-100 h-55",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCustomerId) = $event))
            }, [
              _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.customers.length ? _ctx.$t("sales_page.select_customer") : _ctx.$t("sales_page.loading_customers")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: customer.id,
                  value: customer.id
                }, _toDisplayString(customer.name), 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedCustomerId]
            ]),
            (_ctx.stateStore.activePromotion)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.activePromotion.name), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.promotionSummary), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, [
              _createTextVNode(_toDisplayString(_ctx.$t("sales_page.warehouse")) + " ", 1),
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "bg-white border-0 rounded-1 fs-14 text-optional w-100 h-55",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedWarehouseId) = $event))
            }, [
              _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t("sales_page.select_warehouse")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: warehouse.id,
                  value: warehouse.id
                }, _toDisplayString(warehouse.name), 9, _hoisted_20))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedWarehouseId]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("sales_page.choose_product")), 1),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _ctx.$t('sales_page.scan_search_product'),
                  class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)), ["enter"])),
                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
                }, null, 40, _hoisted_26), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-2",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1)
                ]))]),
                (_ctx.searchResults.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("ul", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (product) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: product.id,
                            class: _normalizeClass(["p-2 border-bottom product-search-item", { 'cursor-pointer hover-bg-light': _ctx.canSelectProduct(product), 'disabled-product': !_ctx.canSelectProduct(product) }]),
                            onClick: ($event: any) => (_ctx.selectProduct(product))
                          }, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(product.name), 1),
                              _createElementVNode("span", _hoisted_32, _toDisplayString(product.code), 1)
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_page.price")) + ": $" + _toDisplayString(product.price), 1),
                              (Number(product.type) === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.getAvailableStock(product) > 0 ? `${_ctx.$t("sales_page.stock")}: ${_ctx.getAvailableStock(product)}` : _ctx.$t("sales_page.out_of_stock")), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t("sales_page.service_item")), 1))
                            ])
                          ], 10, _hoisted_29))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_SelectedProducts),
      _createVNode(_component_SubmitPurchase),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[13] || (_cache[13] = _createElementVNode("img", {
            src: _imports_1,
            alt: "Image"
          }, null, -1)),
          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("sales_page.product_deleted_from_list")), 1)
        ])
      ])
    ])
  ], 64))
}